module.exports = __webpack_public_path__ + "static/media/idea-bulb.ca02cc86.svg";